/*
 * nt-variant-fix.js
 * Relie les pastilles de variantes (section nt-product-page) au formulaire produit.
 * Sans ce script, les pastilles ne font que changer de couleur : le champ
 * input[name="id"] reste figé sur la première variante et EasySell COD
 * reçoit toujours la même.
 */
(function () {
  'use strict';

  function ready(fn) {
    if (document.readyState !== 'loading') { fn(); }
    else { document.addEventListener('DOMContentLoaded', fn); }
  }

  function group3(str, sep) {
    return str.replace(/\B(?=(\d{3})+(?!\d))/g, sep);
  }

  function build(value, decimals, thousandsSep, decimalSep) {
    var fixed = value.toFixed(decimals);
    var parts = fixed.split('.');
    parts[0] = group3(parts[0], thousandsSep);
    return parts.length > 1 ? parts[0] + decimalSep + parts[1] : parts[0];
  }

  function formatMoney(cents, format) {
    if (!format || typeof cents !== 'number') { return null; }
    var value = cents / 100;
    return format.replace(/\{\{\s*(\w+)\s*\}\}/g, function (match, name) {
      switch (name) {
        case 'amount': return build(value, 2, ',', '.');
        case 'amount_no_decimals': return build(value, 0, ',', '.');
        case 'amount_with_comma_separator': return build(value, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return build(value, 0, '.', ',');
        case 'amount_with_space_separator': return build(value, 2, ' ', ',');
        case 'amount_no_decimals_with_space_separator': return build(value, 0, ' ', ',');
        case 'amount_with_apostrophe_separator': return build(value, 2, "'", '.');
        default: return '';
      }
    });
  }

  ready(function () {
    var picker = document.querySelector('.nt-product-info__options');
    var form = document.getElementById('nt-product-form');
    if (!picker || !form) { return; }

    var idInput = form.querySelector('input[name="id"]');
    if (!idInput) { return; }

    var groups = Array.prototype.slice.call(picker.querySelectorAll('.nt-option-pills'));
    if (!groups.length) { return; }

    var variants = null;

    function selectedValues() {
      return groups.map(function (g) {
        var sel = g.querySelector('.nt-option-pill.selected');
        return sel ? sel.textContent.trim() : null;
      });
    }

    function findVariant(values) {
      if (!variants) { return null; }
      for (var i = 0; i < variants.length; i++) {
        var v = variants[i];
        var match = true;
        for (var j = 0; j < values.length; j++) {
          if (values[j] === null) { match = false; break; }
          if (String(v.options[j]).trim() !== String(values[j]).trim()) { match = false; break; }
        }
        if (match) { return v; }
      }
      return null;
    }

    function setText(selector, text) {
      var el = document.querySelector(selector);
      if (el && text) { el.textContent = text; }
    }

    function updatePrice(v) {
      var fmt = window.NT_MONEY_FORMAT;
      var price = formatMoney(v.price, fmt);
      setText('.nt-product-info__price-current', price);
      setText('.nt-sticky-atc-bar__price', price);
      var original = document.querySelector('.nt-product-info__price-original');
      if (original) {
        original.textContent = v.compare_at_price ? (formatMoney(v.compare_at_price, fmt) || '') : '';
      }
    }

    function sync() {
      var v = findVariant(selectedValues());
      if (!v) { return; }

      if (idInput.value !== String(v.id)) {
        idInput.value = v.id;
        idInput.dispatchEvent(new Event('change', { bubbles: true }));
        form.dispatchEvent(new Event('change', { bubbles: true }));
      }

      try {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url.toString());
      } catch (e) { /* URL non supportée : sans conséquence */ }

      updatePrice(v);
    }

    picker.addEventListener('click', function (e) {
      var pill = e.target && e.target.closest ? e.target.closest('.nt-option-pill') : null;
      if (!pill) { return; }

      var g = pill.closest('.nt-option-pills');
      if (g) {
        Array.prototype.forEach.call(g.querySelectorAll('.nt-option-pill'), function (p) {
          p.classList.remove('selected');
        });
        pill.classList.add('selected');
      }

      sync();
    });

    var path = window.location.pathname.split('?')[0].replace(/\/$/, '');
    fetch(path + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (product) {
        if (product && product.variants && product.variants.length) {
          variants = product.variants;
          sync();
        }
      })
      .catch(function () { /* le formulaire garde son comportement d'origine */ });
  });
})();
